export default __webpack_public_path__ + "static/media/d40fc322505e9ffbf065741c4bf7b7db.3e112cbc.png";